import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGoldenlineComponent } from './simple-icons-goldenline.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGoldenlineComponent ],
    exports:      [ SimpleIconsGoldenlineComponent ],
    bootstrap:    []
})
export class SimpleIconsGoldenlineModule {}
